export default __webpack_public_path__ + "static/media/A5_33.269896a1.mp3";